import { FC } from 'react';
import { Chip, SxProps, Theme, useTheme } from '@mui/material';

interface Props {
  avatar: JSX.Element;
  sx?: SxProps<Theme>
}

export const AmenityChip: FC<Props> = ({ avatar, sx }) => {
  const theme = useTheme();
  return (
    <Chip
      size="medium"
      sx={{
        backgroundColor: 'transparent',
        '& svg *': {
          fill: theme.palette.disabled.main
        },
        ...sx
      }}
      avatar={avatar}
    />
  );
};
